import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLiterals } from '~/components/Literals'
import { useInitialLocale } from '~/components/useInitialLocale'

import { getUrlParams } from '../utils'
import actions, { TYPES } from '../actions'
import api from '../api'

function PageSearch({ position, location, history }) {
  const appState = useSelector((state) => state.app)
  const dispatch = useDispatch()
  const { getLiteral } = useLiterals()
  const localeRefValue = useInitialLocale(location.search)

  async function handleSearch(q) {
    const searchParams = position.getParams()

    try {
      let name = q

      if (name.indexOf('%') !== -1) {
        name = name.replace('%', '')
      }

      const searchProductResults = await api.search({
        ...searchParams,
        name,
        locale: localeRefValue.current,
      })

      if (searchProductResults.length === 0) {
        dispatch(
          actions.snack.add({
            id: Date.now(),
            message: `${getLiteral('1997')} ${q}`,
          }),
        )
      }

      dispatch(
        actions.updateApp({
          searchProductResults,
          searchFor: q,
          canBack: true,
          searchLoading: false,
          q,
          mobileBottomShow: true,
        }),
      )
    } catch (error) {
      console.error(error)
      dispatch(actions.snack.add({ id: Date.now(), message: `${getLiteral('2020')} ${q}` }))

      dispatch(actions.updateApp({ searchLoading: false }))
    }
  }

  useEffect(() => {
    const qs = getUrlParams(location.search)
    let shouldFetchProducts = true

    if (appState.searchFor === qs.q) shouldFetchProducts = false

    dispatch(
      actions.updateApp({
        currentProduct: null,
        searchLoading: shouldFetchProducts,
        view: TYPES.VIEW_SEARCH_PRODUCTS,
        q: qs.q,
        stores: null,
      }),
    )

    if (!shouldFetchProducts) return

    if (qs.q.length < 2) return

    if (!position.user?.lat && !position.user?.lng) return

    handleSearch(qs.q)
  }, [location.key, position.fetched, position.user])

  return null
}

export default PageSearch
